var siteHeader = document.getElementById('siteHeader');
var siteMain = document.getElementById('siteMain');
var siteHeaderHeight = $(siteHeader).outerHeight();
if(siteHeader) {
    var fixedOffset = siteHeader.offsetTop;
}

function stickyHeader() {
    // Toggle scrolled class
    if (window.scrollY > fixedOffset) {
        $(siteHeader).addClass('is-fixed');
        $(siteMain).addClass('is-fixed').css('padding-top', siteHeaderHeight + 'px');
        $(siteMain).find('.shadow-overlay').height(siteHeaderHeight);
    } else {
        $(siteHeader).removeClass('is-fixed');
        $(siteMain).removeClass('is-fixed').css('padding-top', '0');
        $(siteMain).find('.shadow-overlay').height(0);
    }
}

window.onscroll = function() {
    stickyHeader();
};